module.exports = __webpack_public_path__ + "fonts/Gilroy-RegularItalic.1a8de21.woff";